// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"koBLqzsZPvYei6fd","wrapper":"_3rWK-Znp0dVYrw0s","star":"cXtvdHLai1zdZl6Z","text":"QRoMGunm_oNh_rDD"};


//////////////////
// WEBPACK FOOTER
// ./src/bundles/honest_work/components/HonestWorkNew/index.css
// module id = 420
// module chunks = 1